module.exports = __webpack_public_path__ + "static/img/background.aa4ec58c.svg";